// Global Modal selectors

export const verifyIfModalIsOpened = (key, state) => {
  return state.globalModal.keyContentComponent === key;
};

export const getGlobalModalKeyContentComponent = state => {
  return state.keyContentComponent;
};

export const getGlobalModalIsVisible = state => {
  return state.isVisible;
};
export const getGlobalModalShouldUseGWComponent = state => {
  return state.shouldUseGWComponent;
};
